// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"45af9eaa","453":"ebd78835","667":"b8390fe7"}[chunkId] + ".chunk.js";
};